export enum ServiceKey {
  WebDevelopment = 'webDevelopment',
  MobileDevelopment = 'mobileDevelopment',
  SoftwareTesting = 'softwareTesting',
  UiuxDesign = 'uiuxDesign',
  DevOps = 'devOps',
  Marketing = 'marketing',
  Seo = 'seo',
  ContentCreation = 'contentCreation',
  GraphicDesign = 'graphicDesign',
  Advertising = 'advertising',
  ItConsulting = 'itConsulting',
  BusinessConsulting = 'businessConsulting',
  StrategyConsulting = 'strategyConsulting',
  FinancialConsulting = 'financialConsulting',
  DesignConsulting = 'designConsulting',
  ManagedIt = 'managedIt',
  CloudServices = 'cloudServices',
  Cybersecurity = 'cybersecurity',
  InfrastructureManagement = 'infrastructureManagement',
  ItSupport = 'itSupport',
  ArchitecturalDesign = 'architecturalDesign',
  CivilEngineering = 'civilEngineering',
  StructuralEngineering = 'structuralEngineering',
  UrbanPlanning = 'urbanPlanning',
  ProjectManagement = 'projectManagement',
  Bookkeeping = 'bookkeeping',
  FinancialReporting = 'financialReporting',
  TaxAdvisory = 'taxAdvisory',
  Auditing = 'auditing',
  Payroll = 'payroll',
}

export const ALL_SERVICES: ServiceKey[] = Object.values(ServiceKey);
